import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Output, Input, ViewChild, HostBinding, HostListener, NgModule } from '@angular/core';
import { createPopper } from '@popperjs/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@storeblocks/button-ng';
import { ButtonModule } from '@storeblocks/button-ng';
const _c0 = ["closeButton"];
const _c1 = ["*"];
function PopupComponent_ng_container_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.headerText);
  }
}
function PopupComponent_ng_container_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PopupComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "div", 5);
    i0.ɵɵtemplate(4, PopupComponent_ng_container_0_span_4_Template, 2, 1, "span", 2);
    i0.ɵɵelementStart(5, "button", 6, 1);
    i0.ɵɵlistener("click", function PopupComponent_ng_container_0_Template_button_click_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickCloseIcon($event));
    });
    i0.ɵɵelementStart(7, "i", 7);
    i0.ɵɵtext(8, "close");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵtemplate(10, PopupComponent_ng_container_0_ng_container_10_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r1.width ? ctx_r1.width : "auto");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.headerText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", "icon")("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("type", "button")("aria-label", ctx_r1.closeButtonLabel)("aria-live", "off")("data-trackId", ctx_r1.closeButtonTrackId);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function PopupComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function PopupComponent_ng_container_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", "header-" + ctx_r1.randomId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.headerText, " ");
  }
}
function PopupComponent_ng_container_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PopupComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "div", 11);
    i0.ɵɵtemplate(3, PopupComponent_ng_container_3_div_3_Template, 2, 2, "div", 12);
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵtemplate(5, PopupComponent_ng_container_3_ng_container_5_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "button", 14, 1);
    i0.ɵɵlistener("click", function PopupComponent_ng_container_3_Template_button_click_6_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickCloseIcon($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", "header-" + ctx_r1.randomId)("aria-describedby", "body-" + ctx_r1.randomId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.headerText);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", "body-" + ctx_r1.randomId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("stbButton", "icon")("colorVariant", "darkRed")("rebrand", true)("iconType", "close")("setIconBefore", true)("disabled", false)("size", "medium");
    i0.ɵɵattribute("data-popover-close", true)("type", "button")("aria-label", ctx_r1.closeButtonLabel);
  }
}
const _c2 = ["toggle"];
const _c3 = ["popup"];
function PopoverComponent_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 7);
    i0.ɵɵtext(1, "information");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", ctx_r1.disabled);
  }
}
let PopupComponent = /*#__PURE__*/(() => {
  class PopupComponent {
    constructor() {
      this.clickCloseIcon = new EventEmitter();
      this.clickBackground = new EventEmitter();
      this.disabled = false;
      this.position = 'auto';
      this.closeButtonTrackId = '';
      this.headerText = '';
      this.rebrand = false;
      this.width = 'auto';
      this.iconSize = 'medium';
      this._zindex = 2048;
    }
    get aHighNumber() {
      return this._zindex;
    }
    ngOnInit() {
      this.random = Math.random().toString(36).substring(2);
      this.randomId = 'stb-pop-' + this.random;
    }
    onClickCloseIcon(event) {
      this.clickCloseIcon.emit(event);
    }
  }
  PopupComponent.ɵfac = function PopupComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopupComponent)();
  };
  PopupComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PopupComponent,
    selectors: [["stb-popup"]],
    viewQuery: function PopupComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeButton = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function PopupComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵstyleProp("z-index", ctx.aHighNumber);
      }
    },
    inputs: {
      disabled: "disabled",
      closeButtonLabel: "closeButtonLabel",
      position: "position",
      closeButtonTrackId: "closeButtonTrackId",
      headerText: "headerText",
      rebrand: "rebrand",
      width: "width",
      iconSize: "iconSize"
    },
    outputs: {
      clickCloseIcon: "clickCloseIcon",
      clickBackground: "clickBackground"
    },
    ngContentSelectors: _c1,
    decls: 4,
    vars: 2,
    consts: [["content", ""], ["closeButton", ""], [4, "ngIf"], [1, "stb-popover"], ["role", "tooltip", 1, "stb-popover-container"], [1, "stb-popover-container-header"], ["role", "button", 1, "stb-popover-container-header-close-icon", 3, "click", "type", "disabled"], [1, "system-icon", "icon-xsmall"], [1, "stb-popover-content"], [4, "ngTemplateOutlet"], ["data-stb-popover-element", "true", "tabindex", "-1", "role", "dialog", 1, "popoverPopoverElement"], [1, "popoverContent"], ["class", "font-large-demibold popoverContentHeader", 4, "ngIf"], [1, "font-body", "popoverContentSection"], [1, "closeButton", 3, "click", "stbButton", "colorVariant", "rebrand", "iconType", "setIconBefore", "disabled", "size"], [1, "font-large-demibold", "popoverContentHeader"]],
    template: function PopupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, PopupComponent_ng_container_0_Template, 11, 12, "ng-container", 2)(1, PopupComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, PopupComponent_ng_container_3_Template, 8, 15, "ng-container", 2);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.rebrand);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.rebrand);
      }
    },
    dependencies: [i1.NgIf, i1.NgTemplateOutlet, i2.StbButtonDirective, i2.ButtonComponent],
    styles: ["@font-face{font-family:System-Icons;src:url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.ttf) format(\"truetype\");text-rendering:optimizeLegibility}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}i.symbol{font-family:Storebrand Symbols!important}i{font-family:System-Icons!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall{font-size:16px!important;line-height:16px!important}.icon-small{font-size:20px!important;line-height:20px!important}.icon-medium{font-size:24px!important;line-height:24px!important}.icon-large{font-size:32px!important;line-height:32px!important}.rebrand.stb-popover{box-shadow:none}.rebrand.stb-popover .stb-popover-container-header span{margin-top:12px;margin-right:12px;font-size:1.5rem;line-height:1.5}@media (max-width: 600px){.rebrand.stb-popover .stb-popover-container-header span{font-size:1.25rem}}.rebrand.stb-popover .stb-popover-container-header-close-icon{width:1.5rem;height:1.5rem;margin-right:15px;margin-top:8px}.rebrand.stb-popover .stb-popover-content p{font-weight:400;font-size:1.125rem;line-height:1.5}@media (max-width: 600px){.rebrand.stb-popover .stb-popover-content p{font-size:1rem}}.rebrand.stb-popover .stb-popover-container{color:#560000;background-color:#ffe7e0;padding:8px 8px 24px 24px}.rebrand.stb-popover .stb-popover-container span,.rebrand.stb-popover .stb-popover-container i.system-icon,.rebrand.stb-popover .stb-popover-content p{color:#560000}.rebrand.stb-popover .stb-popover-container{box-shadow:0 4px 6px #00000024,0 6px 8px #0000001f;border-radius:16px}.rebrand.stb-popover .stb-popover-container-header-close-icon:focus-visible{border-radius:16px;outline:2px solid #0000ff;outline-offset:8px}.rebrand.stb-popover p,.rebrand.stb-popover span{font-family:Storebrand Text,sans-serif}.rebrand.stb-popover span{font-weight:600}.stb-popover{position:absolute;z-index:2;width:max-content;min-width:288px;max-width:560px;box-shadow:0 1px 4px #00000024,0 2px 4px #0000001f}.stb-popover .stb-popover-content,.stb-popover .stb-popover-content *,.stb-popover i.system-icon{color:#fff}@media (max-width: 480px){.stb-popover{max-width:288px}}.stb-popover.stb-top{transform:translate(calc(-50% + 22px));bottom:calc(100% + 8px)}.stb-popover.stb-right{transform:translateY(calc(-50% + 11px));left:42px}.stb-popover.stb-bottom{transform:translate(calc(-50% + 22px));top:calc(100% + 8px)}.stb-popover.stb-left{transform:translateY(calc(-50% + 11px));right:30px}.stb-popover.stb-bottom-left{transform:translateY(27px);right:0}.stb-popover.stb-bottom-right{transform:translateY(27px);left:0}.stb-popover.stb-top-left{transform:translate(calc(-100% + 22px));bottom:calc(100% + 8px)}.stb-popover.stb-top-right{transform:translateY(calc(-100% - 8px));left:0}.stb-popover-container{padding:32px;position:relative;background:#191919;border-radius:2px}.above.stb-popover-container:before{bottom:-10px}.below.stb-popover-container:before{top:-10px}@media (max-width: 480px){.stb-popover-container{padding:16px}}.stb-popover-container-header{display:flex;align-items:center;flex-direction:row;margin-bottom:8px;line-height:24px}.stb-popover-container-header-close-icon{display:flex;border:none;background:none;padding:0;cursor:pointer;width:16px;height:16px;margin-left:auto}.stb-popover-container-header-close-icon:focus{outline:2px solid #00f;outline-offset:4px}.stb-popover-container-header-close-icon:focus:not(:focus-visible){outline:0}.stb-popover-container-header-close-icon:focus-visible{outline:2px solid #00f;outline-offset:4px}.stb-popover-container-header span{font-family:Open Sans Semibold,sans-serif;font-size:18px;line-height:24px;color:#fff}.stb-popover.clampWidth{max-width:288px}.stb-popover-content h1,.stb-popover-content h2,.stb-popover-content h3,.stb-popover-content h4,.stb-popover-content h5,.stb-popover-content h6{color:#fff;margin-bottom:16px}.stb-popover-content p{max-width:400px;font-family:Open Sans,sans-serif;box-sizing:border-box;margin:0;color:#fff;font-size:16px;line-height:24px}@media (max-width: 480px){.stb-popover-content p{font-size:14px;line-height:22px}}.stb-popover-content p b{font-weight:400}.stb-popover-content p a{color:inherit}.stb-popover-content p a:focus,.stb-popover-content p a:hover{text-decoration:none}.stb-popover-content ul{padding:0 0 0 20px}.stb-popover-content ul li{color:#fff;font-size:16px;line-height:24px}@media (max-width: 480px){.stb-popover-content ul li{font-size:14px;line-height:22px}}.stb-popover-screenreader{clip-path:inset(100%);clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}@media (max-width: 480px){.stb-popover{position:fixed;top:0;left:50%;transform:translate(-50%);width:100vw;padding:8px}}\n", ".popoverBase[data-stb-popover=true]{align-items:center;display:flex;justify-content:center}.popoverPopoverElement[data-stb-popover-element=true]{--popover-background-color: var(--p-color-surface-1);--popover-box-shadow: 0 4px 6px 0 rgb(0 0 0 / 14%), 0 6px 8px 0 rgb(0 0 0 / 12%);background:var(--popover-background-color);border-radius:var(--p-corner-radius-small);box-shadow:var(--popover-box-shadow);box-sizing:border-box;display:flex;flex-direction:row;gap:var(--p-spacing-rem-16);justify-content:space-between;max-width:560px;min-width:288px;padding:var(--p-spacing-rem-20);text-align:left;align-items:start}.popoverPopoverElement[data-stb-popover-element=true][data-show-on=hover]{padding:var(--p-spacing-rem-24)}.popoverPopoverElement[data-stb-popover-element=true] .popoverContent{box-sizing:border-box;display:flex;flex-direction:column;gap:var(--p-spacing-rem-08);justify-content:center;width:calc(100% - var(--p-spacing-40))}.popoverPopoverElement[data-stb-popover-element=true] .popoverContent .popoverContentHeader,.popoverPopoverElement[data-stb-popover-element=true] .popoverContent .popoverContentSection{box-sizing:border-box;overflow-wrap:break-word}.popoverPopoverElement[data-stb-popover-element=true] .popoverContent .popoverContentHeader p,.popoverPopoverElement[data-stb-popover-element=true] .popoverContent .popoverContentSection p{color:var(--p-color-text-primary);font-family:Storebrand Text,sans-serif;font-size:1rem;font-weight:400;line-height:1.375rem}@media (min-width: 600px){.popoverPopoverElement[data-stb-popover-element=true] .popoverContent .popoverContentHeader p,.popoverPopoverElement[data-stb-popover-element=true] .popoverContent .popoverContentSection p{font-size:1.125rem;line-height:1.625rem}}\n"],
    encapsulation: 2
  });
  return PopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: find a way to keep typings, while being able to handle any string value
// position options from @popperjs/core:
// export type PositionType =
//   'auto',
//   | 'auto-start'
//   | 'auto-end'
//   | 'top'
//   | 'top-start'
//   | 'top-end'
//   | 'bottom'
//   | 'bottom-start'
//   | 'bottom-end'
//   | 'right'
//   | 'right-start'
//   | 'right-end'
//   | 'left'
//   | 'left-start'
//   | 'left-end'
const positions = ['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end'];
let PopoverComponent = /*#__PURE__*/(() => {
  class PopoverComponent {
    constructor(el) {
      this.el = el;
      this.informationToggleLabel = 'Vis hjelpetekst';
      this.closeButtonLabel = 'Skjul hjelpetekst';
      this.position = 'auto';
      this.toggleTrackId = '';
      this.closeButtonTrackId = '';
      this.headerText = '';
      this.disabled = false;
      this.rebrand = false;
      this.width = 'auto';
      this.colorVariant = 'red';
      this.click = new EventEmitter();
      // unofficial/internal inputs:
      // needed for using popover in radio-buttons & checkbox
      this.forcedTabIndex = '0';
      this.togglePopover = event => {
        // if inside clickable table header - stop propagation so that sorting is not triggered
        if (event) {
          event.stopPropagation();
        }
        this.visible ? this.hide() : this.show();
      };
      this.show = () => {
        this.visible = true;
        this.el.nativeElement.querySelector('stb-popup').setAttribute('data-show', '');
        this.el.nativeElement.querySelector('stb-popup').removeAttribute('aria-hidden');
        this.popper.update();
        // close any other popovers if they are open
        document.querySelectorAll('stb-popover stb-popup[data-show]').forEach(popover => {
          if (popover !== this.el.nativeElement.querySelector('stb-popup')) {
            popover.removeAttribute('data-show');
            popover.setAttribute('aria-hidden', 'true');
          }
        });
        // a11y: when opening the popover, set focus to the close button
        // DISABLED for now - causes weird page-jumps and does more harm than good as of now
        // const closeBtn = this.toggle.nativeElement.querySelector('button[data-popover-close="true"]');
        // if (closeBtn) {
        //   closeBtn.focus();
        // }
      };
      this.hide = () => {
        this.visible = false;
        this.el.nativeElement.querySelector('stb-popup').removeAttribute('data-show');
        this.el.nativeElement.querySelector('stb-popup').setAttribute('aria-hidden', 'true');
        this.popper.update();
        // a11y: set focus back to trigger element when closing the popover
        // const toggleBtn = this.toggle.nativeElement.querySelector('button[data-popover-toggle="true"]');
        // if (toggleBtn) {
        //   toggleBtn.focus();
        // }
      };
      this.handleCloseIconClick = () => {
        this.hide();
      };
      this.handleBackgroundClick = event => {
        // don't do anything if popover is not visible!
        if (!this.visible) {
          return false;
        }
        const withinBoundaries = event.composedPath().includes(this.toggle.nativeElement);
        if (withinBoundaries) {
          // do nothing
        } else {
          this.hide();
        }
      };
    }
    onHandleBackgroundClick($event) {
      this.handleBackgroundClick($event);
    }
    get isRebrand() {
      return this.rebrand;
    }
    ngOnInit() {
      // we set this explicitly, no size-changes should come from "outside"
      this.iconSize = this.rebrand ? 'large' : 'xsmall';
      if (positions.includes(this.position)) {
        // console.log('[stb-popover]: valid position value');
      } else {
        console.warn(`[stb-popover]: invalid position value "${this.position}". Defaulting to "auto"`);
        this.position = 'auto';
      }
      const defaultConfig = {
        placement: this.position,
        boundary: document.body,
        rootBoundary: 'viewport',
        removeOnDestroy: true,
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }, {
          name: 'flip',
          options: {
            fallbackPlacements: ['left', 'right', 'top', 'left']
          }
        }]
      };
      this.popper = createPopper(this.toggle.nativeElement, this.el.nativeElement.querySelector('stb-popup'), defaultConfig);
    }
    ngAfterViewInit() {
      // our main event listener - needs to be in afterInit
      this.toggle.nativeElement.querySelector('button[data-popover-toggle="true"]').addEventListener('click', this.togglePopover);
    }
    ngOnDestroy() {
      this.toggle.nativeElement.querySelector('button[data-popover-toggle="true"]').removeEventListener('click', this.togglePopover);
    }
  }
  PopoverComponent.ɵfac = function PopoverComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopoverComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  PopoverComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PopoverComponent,
    selectors: [["stb-popover"]],
    viewQuery: function PopoverComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7);
        i0.ɵɵviewQuery(_c3, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggle = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function PopoverComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function PopoverComponent_click_HostBindingHandler($event) {
          return ctx.onHandleBackgroundClick($event);
        }, false, i0.ɵɵresolveDocument);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.isRebrand);
      }
    },
    inputs: {
      informationToggleLabel: "informationToggleLabel",
      closeButtonLabel: "closeButtonLabel",
      position: "position",
      toggleTrackId: "toggleTrackId",
      closeButtonTrackId: "closeButtonTrackId",
      headerText: "headerText",
      disabled: "disabled",
      rebrand: "rebrand",
      width: "width",
      colorVariant: "colorVariant",
      forcedTabIndex: "forcedTabIndex",
      iconSize: "iconSize"
    },
    outputs: {
      click: "click"
    },
    ngContentSelectors: _c1,
    decls: 9,
    vars: 30,
    consts: [["toggle", ""], ["popup", ""], [1, "stb-popover-toggle"], [3, "stbButton", "type", "size", "colorVariant", "rebrand", "iconType", "setIconBefore", "disabled"], ["style", "color: #282828;", "class", "icon-xsmall", 3, "disabled", 4, "ngIf"], ["aria-live", "polite"], [3, "clickCloseIcon", "clickBackground", "closeButtonLabel", "closeButtonTrackId", "headerText", "disabled", "rebrand", "iconSize"], [1, "icon-xsmall", 2, "color", "#282828"]],
    template: function PopoverComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 2, 0)(2, "button", 3, 0);
        i0.ɵɵtemplate(4, PopoverComponent_i_4_Template, 2, 2, "i", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5)(6, "stb-popup", 6, 1);
        i0.ɵɵlistener("clickCloseIcon", function PopoverComponent_Template_stb_popup_clickCloseIcon_6_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleCloseIconClick());
        })("clickBackground", function PopoverComponent_Template_stb_popup_clickBackground_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleBackgroundClick($event));
        });
        i0.ɵɵprojection(8);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.iconSize);
        i0.ɵɵclassProp("rebrand", ctx.rebrand);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("stb-popover-toggle-button ", ctx.iconSize, "");
        i0.ɵɵproperty("stbButton", "icon")("type", "icon")("size", ctx.rebrand ? "auto" : "small")("colorVariant", ctx.colorVariant)("rebrand", ctx.rebrand)("iconType", "information")("size", ctx.iconSize)("setIconBefore", ctx.rebrand ? true : false)("disabled", ctx.disabled);
        i0.ɵɵattribute("data-popover-toggle", true)("aria-label", ctx.informationToggleLabel)("data-trackId", ctx.toggleTrackId)("aria-pressed", ctx.visible)("type", "button");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.rebrand);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("width", ctx.width);
        i0.ɵɵproperty("closeButtonLabel", ctx.closeButtonLabel)("closeButtonTrackId", ctx.closeButtonTrackId)("headerText", ctx.headerText)("disabled", ctx.disabled)("rebrand", ctx.rebrand)("iconSize", ctx.iconSize);
      }
    },
    dependencies: [i1.NgIf, i2.StbButtonDirective, i2.ButtonComponent, PopupComponent],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}@font-face{font-family:System-Icons;src:url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.ttf) format(\"truetype\");text-rendering:optimizeLegibility}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}i.symbol[_ngcontent-%COMP%]{font-family:Storebrand Symbols!important}i[_ngcontent-%COMP%]{font-family:System-Icons!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i[_ngcontent-%COMP%]:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall[_ngcontent-%COMP%]{font-size:16px!important;line-height:16px!important}.icon-small[_ngcontent-%COMP%]{font-size:20px!important;line-height:20px!important}.icon-medium[_ngcontent-%COMP%]{font-size:24px!important;line-height:24px!important}.icon-large[_ngcontent-%COMP%]{font-size:32px!important;line-height:32px!important}.stb-popover-toggle[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]{color:inherit;display:flex}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]   stb-popup[_ngcontent-%COMP%]{display:none}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]   stb-popup[data-show][_ngcontent-%COMP%]{display:block}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]   .xsmall[_ngcontent-%COMP%], .stb-popover-toggle.rebrand[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]{height:16px;width:16px}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]   .medium[_ngcontent-%COMP%]{height:20px;width:20px}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]   .large[_ngcontent-%COMP%]{height:24px;width:24px}.stb-popover-toggle.rebrand[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#700}.stb-popover-toggle[_ngcontent-%COMP%]   stb-popup[_ngcontent-%COMP%]{display:none}.stb-popover-toggle[_ngcontent-%COMP%]   stb-popup[data-show][_ngcontent-%COMP%]{display:block}.stb-popover-toggle-button[_ngcontent-%COMP%]{border:none;background:none;width:22px;height:22px;min-width:unset;padding:0;cursor:pointer;display:flex;align-items:center}@media (max-width: 480px){.stb-popover-toggle-button[_ngcontent-%COMP%]{width:20px;height:20px}}.stb-popover-toggle-button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{color:#191919;text-indent:100px;white-space:nowrap;overflow:hidden;cursor:pointer;position:relative}.stb-popover-toggle-button[_ngcontent-%COMP%]   i.disabled[_ngcontent-%COMP%]{color:#757575}.stb-popover-toggle-button[_ngcontent-%COMP%]:focus-visible{outline:2px solid #00f;outline-offset:4px}.stb-popover-toggle[_ngcontent-%COMP%]   .xsmall[_ngcontent-%COMP%]{width:16px;height:16px}.stb-popover-toggle[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]{width:20px;height:20px}.stb-popover-toggle[_ngcontent-%COMP%]   .medium[_ngcontent-%COMP%]{width:24px;height:24px}.stb-popover-toggle[_ngcontent-%COMP%]   .large[_ngcontent-%COMP%]{width:32px;height:32px}.stb-popover-toggle[_ngcontent-%COMP%]   .xsmall[_ngcontent-%COMP%]:not(.rebrand), .stb-popover-toggle[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:not(.rebrand), .stb-popover-toggle[_ngcontent-%COMP%]   .medium[_ngcontent-%COMP%]:not(.rebrand), .stb-popover-toggle[_ngcontent-%COMP%]   .large[_ngcontent-%COMP%]:not(.rebrand){min-width:unset;position:relative}.stb-popover-toggle[_ngcontent-%COMP%]   .xsmall[_ngcontent-%COMP%]:not(.rebrand):hover, .stb-popover-toggle[_ngcontent-%COMP%]   .small[_ngcontent-%COMP%]:not(.rebrand):hover, .stb-popover-toggle[_ngcontent-%COMP%]   .medium[_ngcontent-%COMP%]:not(.rebrand):hover, .stb-popover-toggle[_ngcontent-%COMP%]   .large[_ngcontent-%COMP%]:not(.rebrand):hover{background:unset}.stb-popover-toggle-button[_ngcontent-%COMP%]:not(.default)::-moz-focus-inner{border-style:none}.sr-only[_ngcontent-%COMP%]{clip-path:inset(100%);clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}"]
  });
  return PopoverComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PopoverModule = /*#__PURE__*/(() => {
  class PopoverModule {}
  PopoverModule.ɵfac = function PopoverModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopoverModule)();
  };
  PopoverModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PopoverModule
  });
  PopoverModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, ButtonModule]
  });
  return PopoverModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of popover
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PopoverComponent, PopoverModule, PopupComponent };
